import React, { useEffect } from 'react'
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

/* Chart code */
// Themes begin
am4core.useTheme(am4themes_animated);
// Themes end

const StackIncomeChart = ({ data, xAxis, lstRenderLine }) => {

    useEffect(() => {

        let chart = am4core.create("chart-income", am4charts.XYChart3D) as any;

        chart.data = data;

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis()) as any;
        categoryAxis.dataFields.category = xAxis;
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 20;
        categoryAxis.renderer.labels.template.fontSize = 12;

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = "ล้านบาท";
        valueAxis.renderer.labels.template.fontSize = 12;
        valueAxis.extraMax = 0.1; 
        valueAxis.numberFormatter = new am4core.NumberFormatter();
        valueAxis.numberFormatter.numberFormat = "#.00"; 
        valueAxis.adjustLabelPrecision = false;
        // Create series
        function createSeries(field, name, stacked, sTooltip,Color) {
            let series = chart.series.push(new am4charts.ColumnSeries3D());
            series.dataFields.valueY = field;
            series.dataFields.categoryX = xAxis;
            series.name = name;
            series.columns.template.tooltipText = sTooltip + ": {valueY}[/]";
            series.stacked = stacked;
            series.columns.template.width = am4core.percent(50);
            series.columns.template.stroke = am4core.color(Color); // red outline
            series.columns.template.fill = am4core.color(Color); // green fill
            
            // Add label
            let labelBullet = series.bullets.push(new am4charts.LabelBullet());
            labelBullet.label.fontSize = 12; 
            labelBullet.label.fontWeight = "normal"; 
            labelBullet.label.text = "{valueY.formatNumber('#.00')}";
            labelBullet.locationY = 0.5;
            labelBullet.label.hideOversized = true;
            labelBullet.label.fill = am4core.color("#FFFFFF");
        
         
        }

        
        lstRenderLine.forEach((element) => {
            createSeries(element.sValue, element.label, true, element.label,element.sColor);
        });

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = "แผนรายได้";
        lineSeries.dataFields.valueY = "nPlan";
        lineSeries.dataFields.categoryX = xAxis;
        lineSeries.showOnInit = true;
        lineSeries.stroke = am4core.color("#fdd400");
        lineSeries.strokeWidth = 2;
        lineSeries.tooltip.label.textAlign = "middle";

        // Add labels to the series
        let labelBullet = lineSeries.bullets.push(new am4charts.LabelBullet());
        labelBullet.label.text = "{valueY.formatNumber('#.00')}";
        labelBullet.label.dy = -15;
        labelBullet.label.fontSize = 12; 


        let bullet = lineSeries.bullets.push(new am4charts.Bullet());
        bullet.fill = am4core.color("#fdd400");
        bullet.tooltipText = "[#fff font-size: 12px]แผนรายได้: [/][#fff font-size: 12px]{valueY}[/]"
        let circle = bullet.createChild(am4core.Circle);
        circle.radius = 3;
        circle.fill = am4core.color("#fff");
        circle.strokeWidth = 4;

        /* Create legend */
        chart.legend = new am4charts.Legend();
        chart.legend.maxHeight = 195;
        chart.legend.scrollable = true;
        chart.legend.fontSize = 12; // Set the font size here

        // Cleanup on component unmount
        return () => {
            chart.dispose();
        };

    }, [data, lstRenderLine, xAxis])


    return (
            <div id="chart-income" style={{ width: "100%", height: "600px" }}></div>
    )
}

export default StackIncomeChart